<template>
  <app-data-editor
    :id="id"
    title="Редактирование Клиента"
    resource="clients"
    :elements="elements"
    add-message="Клиент добавлен"
    edit-message="Клиент изменен"
  />
</template>

<script>
import mixin from "../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [
                (v) => !!v || "Наименование обязательно к заполнению",
                (v) =>
                  v.length >= 3 ||
                  "Наименование должно содержать не менее 3-х символов",
              ],
            },
            default: "",
          },
        ],
        [
          {
            title: "Корпоративный телефон",
            name: "phone",
            control: {
              type: "phone",
            },
            default: "",
          },
          {
            title: "Корпоративный Email",
            name: "email",
            control: {
              type: "email",
            },
            default: "",
          },
        ],
        [
          {
            title: "Сайт",
            name: "webSite",
            control: {
              type: "text",
            },
            default: "",
          },
          {
            title: "Источник",
            name: "source",
            control: {
              type: "text",
              required: true,
              rules: [
                (v) => !!v || "Источник обязателен к заполнению",
                (v) =>
                  v.length >= 3 ||
                  "Источник должен содержать не менее 3-х символов",
              ],
            },
            default: "",
          },
        ],
        [
          {
            title: "Реферал",
            name: "refferal",
            control: {
              type: "text",
            },
            default: "",
          },
          {
            title: "Нюансы взаимодействия, специфика",
            name: "notes",
            control: {
              type: "text",
            },
            default: "",
          },
        ],
        [
          {
            title: "Адрес",
            name: "address",
            control: {
              type: "reference",
              component: "Address",
              resource: "addresses",
            },
          },
          {
            title: "Юр. адрес",
            name: "legalAddress",
            control: {
              type: "reference",
              component: "Address",
              resource: "addresses",
            },
          },
        ],
        [
          {
            title: "Менеджер",
            name: "manager",
            control: {
              type: "manager-select",
              component: "Employee",
              resource: "employees",
              required: true,
              rules: [(v) => !!v || ""],
            },
          },
          {
            title: "Категория",
            name: "category",
            control: {
              type: "enum",
              resource: "client-categories",
            },
          },
        ],
        [
          {
            title: "Род деятельности",
            name: "activityType",
            control: {
              type: "reference",
              component: "ActivityType",
              resource: "activity-types",
            },
          },
        ],
        [
          {
            title: "Контактные лица",
            name: "contactPersons",
            getDataPath: "Contacts",
            saveDataPath: "Contacts",
            control: {
              type: "reference-list",
              resource: "contact-persons",
              searchPlaceholder: "Контактное лицо",
              component: "ContactPerson",
              columns: [
                { title: "Имя", name: "name" },
                { title: "Фамилия", name: "surname" },
                {
                  title: "Телефон",
                  name: "phones",
                  valueFn(item) {
                    return Array.isArray(item.phones)
                      ? item.phones.length > 1
                        ? item.phones.join(", ")
                        : item.phones.join()
                      : item.phones;
                  },
                },
                {
                  title: "Email",
                  name: "emails",
                  valueFn(item) {
                    return Array.isArray(item.emails)
                      ? item.phones.length > 1
                        ? item.emails.join(", ")
                        : item.emails.join()
                      : item.emails;
                  },
                },
                { title: "Роль", name: "role", data: "role.title" },
              ],
              dataTest: "contactPerson",
            },
            default: [],
          },
        ],
        [
          {
            title: "Название клиента на фабриках",
            name: "Aliases",
            control: {
              type: "editable-string-list",
              dataTest: "aliase",
              itemsPerView: 5,
            },
            default: [],
          },
        ],
      ],
    };
  },
};
</script>
